export default __webpack_public_path__ + "media/zurb/img/experience-design/stat-table1-64243fde2f31de2d53e3c5e196bccb5b.png";